<i18n>
{
	"en": {
		"title" : "Edit outbound EDI Setup",
		"notifyEdipartSaved": "Outbound EDI setup saved"
	},
	"no":{
		"title" : "Rediger utgående EDI oppsett",
		"notifyEdipartSaved": "Utgående EDI oppsett lagret"
	}
}
</i18n>

<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isDialogShown"
		:icon="'settings'"
		iconType="bp"
		@close="$emit('close')"
		@ok="save"
		@cancel="close"
	>
		<OutboundSettings style="height:500px;" :outboundEdiSetting="outboundEdiSetting"/>

	</t-dialog>

</template>

<script>

import OutboundSettings from './OutboundSettings';
import { mapActions } from '../store/details/ediSetupDetails.store';
export default {

	components: { OutboundSettings },
	props: { isDialogShown: Boolean, outboundEdiSetting: Object, id: String },

	methods: {
		...mapActions(['executeSaveOutboundSettings']),
		close() {
			this.$emit('close');
		},
		save() {
			this.executeSaveOutboundSettings(this.outboundEdiSetting);
			this.$notify({
				type: 'success',
				title: this.$t('notifyEdipartSaved')
			});
		},
	}

};
</script>

<style>

</style>